import classNames from 'classnames';
import { useState } from 'react';
import ConfigurationFlowPaxModal from '@/components/modules/configuration-flow/configuration-flow-pax-modal/configuration-flow-pax-modal';
import SearchBarSection from '@/components/molecules/search-bar-section/search-bar-section';
import { generatePersonsSectionValueString } from '@/components/organisms/search-bar/shared/search-utils/search-utils';
import { useI18n } from '@/libraries/contexts/i18n-context';
import {
  SearchBarWrapperSectionData,
  SearchBarWrapperSectionType,
} from '../search-bar/search-bar.types';
import styles from './search-bar-persons.module.scss';

export interface SearchBarPersonsProps {
  /** The class name to apply */
  className?: string;
  /** The search settings */
  searchSettings: Content.Components['SearchSettingsDto'];
}

const SearchBarPersons = ({
  className,
  searchSettings,
}: SearchBarPersonsProps) => {
  const { t } = useI18n();
  const [isPaxModalOpen, setIsPaxModalOpen] = useState(false);

  const personsSection: SearchBarWrapperSectionData = {
    dropdownData: {
      adultThreshold: searchSettings.adultAgeThreshold,
      defaultAdultNumber: searchSettings.defaultNumberOfAdultsPerRoom,
      maxPersons: searchSettings.maxNumberOfAdults,
      maxRooms: searchSettings.maxNumberOfRooms,
      roomDistributionWarning: searchSettings.roomDistributionWarning,
      roomsState: {
        automaticRoomAssignment: true,
        rooms: [
          {
            childrenAges: [],
            numberOfAdults: searchSettings.defaultNumberOfAdultsPerRoom,
            numberOfChildren: 0,
          },
        ],
      },
    },
    id: 2,
    label: t('items.search.searchBar.persons.personsTitle'),
    placeholder: t('items.search.searchBar.persons.personsPlaceholder'),
    type: SearchBarWrapperSectionType.PERSONS,
    value: generatePersonsSectionValueString({
      adults: searchSettings?.selectedPaxDistribution?.adultsNo,
      children: searchSettings?.selectedPaxDistribution?.childrenNo,
      t,
    }),
  };

  return (
    <div className={classNames(styles.component, className)}>
      <div className={styles.searchBarWrapper}>
        <div className={styles.searchSectionWrapper}>
          <SearchBarSection
            className={styles.searchSection}
            label={personsSection.label}
            onClick={() => setIsPaxModalOpen(true)}
            placeholder={personsSection.placeholder}
            value={personsSection.value}
          />
        </div>
      </div>

      <ConfigurationFlowPaxModal
        key={JSON.stringify(searchSettings)}
        isOpen={isPaxModalOpen}
        searchSettings={searchSettings}
        setIsOpen={value => setIsPaxModalOpen(value)}
      />
    </div>
  );
};

SearchBarPersons.displayName = 'SearchBarPersons';

export default SearchBarPersons;
